import type { SVGProps } from "react";
export interface AlienIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AlienIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AlienIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 11a7.875 7.875 0 0 0-15.75 0c0 2.362 1.315 4.853 3.092 6.804.877.963 1.829 1.752 2.71 2.291.91.557 1.633.78 2.073.78s1.162-.223 2.073-.78c.881-.54 1.833-1.328 2.71-2.29 1.777-1.952 3.092-4.443 3.092-6.805m2.25 0c0 3.137-1.7 6.146-3.68 8.32-1.002 1.1-2.115 2.03-3.199 2.694-1.055.646-2.201 1.11-3.246 1.11s-2.19-.464-3.246-1.11c-1.084-.663-2.197-1.594-3.2-2.694-1.98-2.174-3.679-5.183-3.679-8.32C1.875 5.408 6.408.875 12 .875S22.125 5.408 22.125 11"
      />
      <path
        fill={color}
        d="m13 16.875.115.005a1.125 1.125 0 0 1 0 2.239l-.116.006H11a1.125 1.125 0 0 1 0-2.25zm-4.941-7.98c.654.06 1.473.274 2.122.923.65.65.863 1.468.923 2.123s-.021 1.273-.073 1.635c-.071.495-.46.884-.955.955-.362.051-.98.133-1.635.073s-1.474-.274-2.123-.923-.861-1.468-.921-2.122c-.06-.656.022-1.273.073-1.635l.041-.18c.129-.407.48-.712.913-.774.362-.051.98-.135 1.635-.074Zm7.882 0c.491-.045.961-.01 1.318.033l.317.042.18.041c.407.129.713.48.775.913.051.362.133.98.073 1.635-.06.654-.274 1.473-.923 2.122-.649.65-1.468.863-2.122.923-.656.06-1.273-.021-1.635-.073a1.125 1.125 0 0 1-.954-.955c-.052-.362-.133-.98-.073-1.635s.272-1.474.921-2.123c.65-.649 1.468-.862 2.123-.922Zm-8.304 2.459c.034.373.137.601.272.736.135.136.364.239.738.273q.112.009.225.009c-.002-.075-.002-.15-.01-.224-.034-.374-.136-.604-.272-.739-.135-.135-.363-.238-.736-.272a3 3 0 0 0-.228-.01q.002.114.01.226Zm8.51-.217c-.373.034-.603.137-.738.272s-.238.365-.272.739q-.01.111-.01.224c.075-.002.152-.002.226-.01.374-.034.602-.136.737-.272.136-.135.238-.363.273-.736q.009-.113.009-.227-.113 0-.224.01Z"
      />
    </svg>
  );
}
